



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDPLANPOST
// ADDPLANPOST
const ADDPLANPOST= createAsyncThunk(
  "addPlanPost/addPlanPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addPlanPostSlice = createSlice({
  name: "addPlanPostSlice",
  initialState: {
    addPlanPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddPlanPost: (state) => {
        state.addPlanPost.loading = false
        state.addPlanPost.error = false
        state.addPlanPost.data = []
        state.addPlanPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDPLANPOST.fulfilled, (state, action) => {
      state.addPlanPost = {
        ...state.addPlanPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPLANPOST.pending, (state, action) => {
      state.addPlanPost = {
        ...state.addPlanPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPLANPOST.rejected, (state, action) => {
      state.addPlanPost = {
        ...state.addPlanPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addPlanPostAction = {
    ADDPLANPOST,
};

export { addPlanPostAction };
export default addPlanPostSlice.reducer;
export const {setInitialStateOfaddPlanPost} = addPlanPostSlice.actions